import { Placeholder } from 'react-bootstrap';
import './card.css';

const MarketplaceCardSkeleton = () => {
  return (
    <div className="marketplace-card skeleton">
      <div className="marketplace-card-image skeleton-image"></div>
      <div className="marketplace-card-content">
        <div className="marketplace-card-pricebox">
          <div>
            <Placeholder xs={4} />
            <Placeholder xs={3} />
            <Placeholder xs={2} />
          </div>
          <div>
            <Placeholder xs={4} />
            <Placeholder xs={3} />
          </div>
        </div>

        <Placeholder as="p" animation="wave">
          <Placeholder xs={4} />
        </Placeholder>
      </div>
    </div>
  );
};

export default MarketplaceCardSkeleton;
